import { render, staticRenderFns } from "./PuppyTable.vue?vue&type=template&id=2f3739e4"
import script from "./PuppyTable.vue?vue&type=script&lang=ts"
export * from "./PuppyTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports